import { CityContext } from "@/contexts/city-context-provider";
import { useSetQueryParams } from "@/hooks/use-set-query-params";
import { UrbanFeatureType } from "@/types/gql/graphql";
import { getQueryParams } from "helper/utils";
import { useContext, useState } from "react";

export type FilterUrbanFeature = {
  selectedUrbanTypes: UrbanFeatureType[];
};
export const useSearchFilterUrbanFeature = () => {
  const params = getQueryParams();
  const setQueryParams = useSetQueryParams();
  const { currentCity } = useContext(CityContext);

  const currentFilter = {
    selectedUrbanTypes: params.urbanTypes?.split(",") ?? [],
  } as FilterUrbanFeature;
  const [filter, setFilter] = useState<FilterUrbanFeature>(currentFilter);

  const changeFilter = (input: FilterUrbanFeature) => {
    setFilter(input);
    if (currentCity) {
      setQueryParams(
        {
          cityID: currentCity.id,
          urbanTypes: input.selectedUrbanTypes,
        },
        { merge: true },
      );
    }
  };
  return {
    filter,
    changeFilter,
  };
};
